module.exports = __webpack_public_path__ + "static/party_bn3M@2x-4d4466517a9979b59cf4991b74e0eb07.png";